import { render, staticRenderFns } from "./VTextMatrix.vue?vue&type=template&id=5671210a&scoped=true"
import script from "./VTextMatrix.vue?vue&type=script&lang=js"
export * from "./VTextMatrix.vue?vue&type=script&lang=js"
import style0 from "./VTextMatrix.vue?vue&type=style&index=0&id=5671210a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5671210a",
  null
  
)

export default component.exports